import { useState, type ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import Header from "./Header";
import { cn } from "@/lib/utils";

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen flex flex-col bg-gray-20">
      {/* Header - visible uniquement sur tablette/mobile, caché quand sidebar ouverte */}
      <Header
        onMenuClick={() => setSidebarOpen(true)}
        sidebarOpen={sidebarOpen}
      />

      <div
        className={cn(
          "flex flex-1 overflow-hidden transition-all duration-300",
          sidebarOpen ? "pt-0" : "pt-16 lg:pt-0" // Pas de padding-top quand sidebar ouverte
        )}
      >
        {/* Overlay pour tablette */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Contenu principal */}
        <main className="flex-1 p-4 md:p-6 overflow-auto">{children}</main>
      </div>
    </div>
  );
};
